import { BrowserModule } from "@angular/platform-browser";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { RouterModule } from "@angular/router";
import { AppRoutes } from "./app.routing";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { CoreModule } from "./core/core.module";
/* to load and set en.json as the default application language */

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    CommonModule,
    SharedModule,
    BrowserModule,
	ReactiveFormsModule,
	FormsModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    GooglePlaceModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
  exports: [RouterModule],
  entryComponents: [],
})
export class AppModule {}
